export default class GreetingPage {
	constructor($root, mainController) {
		this.$root = $root;
		this.$icon = this.$root.querySelector('.quiz-greeting_icon');
		this.$quizTip = this.$root.querySelector('.quiz-greeting_tip');
		this.$totalQuestions = this.$root.querySelector('.quiz_total-questions');
		this.$passGrade = this.$root.querySelector('.quiz_pass-grade');
		this.$footer = this.$root.querySelector('.quiz-page_footer');
		this.$beginBtn = this.$root.querySelector('.quiz-page_begin');
		this.$backBtn = this.$root.querySelector('.quiz-page_prev');

		this.mainController = mainController;

		this.isInitialized = false;
	}

	init(switchPage) {
		this.setQuizIcon();
		this.$quizTip.textContent = this.mainController.storage.quizDescription;
		this.$totalQuestions.textContent = this.mainController.storage.totalQuestions;
		this.$passGrade.textContent = this.mainController.storage.quizPassGrade;

		if (this.mainController.isMultiple) {
			this.$footer.classList.add('-multiple');
		}

		if (!this.isInitialized) {
			this.$beginBtn.addEventListener('click', e => {
				e.preventDefault();
				switchPage('next');
			});

			this.$backBtn.addEventListener('click', e => {
				e.preventDefault();
				switchPage('prev');
			});

			this.isInitialized = true;
		}
	}

	setQuizIcon() {
		const iconUrl = this.mainController.storage.iconUrl ?
			this.mainController.storage.iconUrl :
			`${craft.env.assetsSiteUrl}/online/images/Tests/Test-Tech.svg`;
		this.$icon.style.backgroundImage = `url(${iconUrl})`;
	}
}